import React from 'react'
import { Edit } from 'react-admin'
import PageForm from './form'

export const PageEdit = (props) => (
  <Edit undoable={false} {...props}>
    <PageForm {...props} />
  </Edit>
)

export default PageEdit
